module.exports = __webpack_public_path__ + "static/media/bar-code.50a417d9.svg";